<!--
 * @Author: vince
 * @Date: 2021-09-05 16:03:44
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-22 19:05:18
 * @Description:
-->
<template>
  <el-container>
    <el-header class="head">
      <div class="reportTab">
        <span class="is-active">校级报表</span>
      </div>
    </el-header>
    <el-main v-loading="loading">
      <div class="bg-white pa-md">
        <el-form class="full-width mb-2px" :model="filterForm">
          <div class="filter-bar pa-none">
            <el-form-item class="mb-none" label="学年">
              <school-year-selector
                checkAll
                v-model="filterForm.schoolYear"
                @change="refresh"
              ></school-year-selector>
            </el-form-item>
            <el-form-item class="mb-none" label="学期">
              <school-term-selector
                v-model="filterForm.schoolTerm"
                @change="refresh"
              ></school-term-selector>
            </el-form-item>
            <el-form-item class="mb-none" label="校区">
              <school-selector
                checkAll
                v-model="filterForm.schoolTemp"
                @change="refresh"
              ></school-selector>
            </el-form-item>
            <div class="space"></div>
          </div>
        </el-form>
        <el-row>
          <el-col :span="12">
            <div class="chart-box">
              <div class="box">
                <echarts :option="option1"></echarts>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="chart-box">
              <div class="box">
                <echarts :option="option2"></echarts>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="filter-row pa-md">
          <el-input
            v-model="filterForm.keyword"
            size="small"
            clearable
            placeholder="搜索教师姓名"
            style="width: 270px"
          >
            <template v-slot:append>
              <span @click="refresh">搜索</span>
            </template>
          </el-input>
          <el-button
            size="small"
            @click="exportExcel"
            class="ml-md"
            icon="el-icon-upload2"
            type="primary"
            :disable="tableData.length == 0"
            >导出</el-button
          >
        </div>
        <el-table
          :data="tableData"
          header-cell-class-name="tbh"
          style="width: 100%"
        >
          <el-table-column
            prop="userName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="researchCount"
            label="教研活动次数"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.researchJoinCount }}
            </template>
          </el-table-column>
          <el-table-column
            prop="trainingCount"
            label="培训次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="topicCount"
            label="项目/课题研究次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="designCount"
            label="教学设计次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="articleCount"
            label="学术文章次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="radiationCount"
            label="示范辐射次数"
            align="center"
          ></el-table-column>
          <pagination
            v-if="tableData.length > 0"
            class="mb-md mr-md"
            slot="append"
            :pageObj="filterForm"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></pagination>
        </el-table>
        <el-table
          id="table"
          v-show="false"
          :data="allData"
          header-cell-class-name="tbh"
          style="width: 100%"
        >
          <el-table-column
            prop="userName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="researchJoinCount"
            label="教研活动次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="trainingCount"
            label="培训次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="topicCount"
            label="项目/课题研究次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="designCount"
            label="教学设计次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="articleCount"
            label="学术文章次数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="radiationCount"
            label="示范辐射次数"
            align="center"
          ></el-table-column>
          <pagination
            v-if="tableData.length > 0"
            class="mb-md mr-md"
            slot="append"
            :pageObj="filterForm"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></pagination>
        </el-table>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import DicSelector from "../../components/school/dicSelector.vue";
import pagination from "../../components/Pagination.vue";
import schoolYearSelector from "../../components/school/schoolYearSelector.vue";
import schoolTermSelector from "../../components/school/schoolTermSelector.vue";
import SchoolSelector from "../../components/school/schoolSelector.vue";
import { postData, postJson } from "../../http/fetch.js";
import Echarts from "../../components/echarts.vue";
import { mapGetters, mapState } from "vuex";
import { downlaodHandler } from "@/utils/index.js";
export default {
  name: "schoolReport",
  data() {
    return {
      allData: [],
      loading: false,
      tableData: [],
      resourceStatisticsData: [],
      filterForm: {
        keyword: null,
        schoolYear: null,
        schoolTerm: null,
        school: null,
        total: 0,
        current: 1,
        size: 10,
      },
    };
  },
  components: {
    schoolYearSelector,
    schoolTermSelector,
    SchoolSelector,
    Echarts,
    pagination,
    DicSelector,
  },
  computed: {
    ...mapState(["schoolList"]),
    ...mapGetters(["schoolCodes"]),
    option1() {
      return {
        title: {
          text: "资源占比",
          left: "center",
          top: "5%",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "10%",
        },
        color: [
          "#3AA0FF",
          "#36CBCB",
          "#4DCB73",
          "#FAD337",
          "#F2637B",
          "#975FE4",
          "#FFCB91",
          "#B5C347",
        ],
        series: [
          {
            label: {
              formatter: "{name|{b}  {c}}\n{time|{d} %}",
              minMargin: 5,
              edgeDistance: 10,
              rich: {
                time: {
                  fontSize: 10,
                  color: "#999",
                },
              },
            },
            name: "资源占比",
            type: "pie",
            radius: "50%",
            data: this.resourceStatisticsData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
    option2() {
      return {
        title: {},
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        color: ["#1890FF"],
        xAxis: [
          {
            type: "category",
            axisLine: {
              color: "#D9D9D9",
            },
            axisLabel: {
              fontFamily: "pfrgl",
              interval: 0,
            },
            axisTick: {
              alignWithLabel: true,
              color: "#D9D9D9",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            splitArea: false,
          },
        ],
        series: [
          {
            label: {
              show: true,
              position: "top",
            },
            name: "数量",
            type: "bar",
            barWidth: "40%",
            data: this.resourceStatisticsData
              ? this.resourceStatisticsData.map((m) => {
                  return [m.name, m.value];
                })
              : [],
          },
        ],
      };
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    exportExcel() {
      postJson("/teacherDevelopment/resourceStatisticsInfo", {
        keyword: this.filterForm.keyword,
        schoolCodes: this.filterForm.schoolTemp
          ? [this.filterForm.schoolTemp.schoolCode]
          : this.schoolCodes,
        schoolTerm: this.filterForm.schoolTerm,
        schoolYear: this.filterForm.schoolYear,
        pageSize: -1,
        pageNum: 1,
      }).then((res) => {
        if (res.records.length > 0) {
          this.allData = res.records;
          this.$nextTick(() => {
            downlaodHandler("#table", "教师资源报表");
          });
        } else {
          this.allData = [];
        }
      });
    },
    refresh() {
      this.filterForm.current = 1;
      this.resourceStatistics();
      this.resourceStatisticsInfo();
    },
    //校级报表
    resourceStatistics() {
      this.loading = true;
      postJson("/teacherDevelopment/resourceStatistics", {
        keyword: this.filterForm.keyword,
        schoolCodes: this.filterForm.schoolTemp
          ? [this.filterForm.schoolTemp.schoolCode]
          : this.schoolList.map((i) => i.schoolCode),
        schoolTerm: this.filterForm.schoolTerm,
        schoolYear: this.filterForm.schoolYear,
      })
        .then((res) => {
          this.resourceStatisticsData = res.map((m) => {
            return { name: m.name, value: m.value || 0 };
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.filterForm.current = 1;
      this.filterForm.size = pageSize;
      this.resourceStatisticsInfo();
    },
    handleCurrentChange(curPage) {
      this.filterForm.current = curPage;
      this.resourceStatisticsInfo();
    },
    resourceStatisticsInfo() {
      this.loading = true;
      postJson("/teacherDevelopment/resourceStatisticsInfo", {
        keyword: this.filterForm.keyword,
        schoolCodes: this.filterForm.schoolTemp
          ? [this.filterForm.schoolTemp.schoolCode]
          : this.schoolCodes,
        schoolTerm: this.filterForm.schoolTerm,
        schoolYear: this.filterForm.schoolYear,
        pageSize: this.filterForm.size,
        pageNum: this.filterForm.current,
      })
        .then((res) => {
          if (res.records.length > 0) {
            this.tableData = res.records;
          } else {
            this.tableData = [];
          }
          this.filterForm.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less">
.el-input-group__append {
  cursor: pointer;
  background: @color;
  color: #fff;
}
</style>
